import { CompanyTableHeader } from "../interfaces/companies";

export const COMPANY_TABLE_HEADERS: CompanyTableHeader[] = [
  { key: 'id', friendly: 'ID' },
  { key: 'name', friendly: 'Name' }
];

export const COMPANY_ACCESS_ATTRIBUTES = [
  'US Resident'
]